export default {
    API_ENDPOINT: 'https://protected-bayou-85097.herokuapp.com/api'
}

//http://localhost:8000/api
//https://protected-bayou-85097.herokuapp.com/api